import { useState } from "react";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { Button } from "primereact/button";
import { IVotingQuestions } from "../../models/VotingQuestions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";

const schema = yup.object({
    submitted_Answer: yup.string()
})

interface Iprops {
    singleData: IVotingQuestions
    open: boolean,
    toast: any,
    hideDialog: () => void,
    isActive: string | boolean
}


const ShowYourAnswers=({props,setLoadings}:{props: Iprops,setLoadings:any})=>{

    const [shwYourAns,setShwYourAns]=useState(props.singleData.submitted_Answer === "" ? true : false );

    const { control, handleSubmit } = useForm<IVotingQuestions>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    function onSubmit(data: IVotingQuestions) {
        saveToDB(data);
    }

    const saveToDB = async (body: IVotingQuestions) => {

        if(body.submitted_Answer==="Yes"){
            body.submitted_Answer = 1;
        } else if(body.submitted_Answer==="No"){
            body.submitted_Answer = 0;
        }

        const data = {
            Que_ID: body.voting_Que_ID,
            Submitted_Answer: body.submitted_Answer
        }
        
        const method = props.singleData.submitted_Answer ? 'PUT' : 'POST';
        const message = props.singleData.question = 'Submitted';
        const response = await Fetch("Voting_Questions/addAnswer", method, data, null, props.toast);

        if (response) {
            
            setShwYourAns(false);
            props.hideDialog();
            props.toast?.current?.show({ severity: 'success', summary: 'Successful', detail: message, life: 3000 });
            setLoadings();
        }
       
    }

    return <div>
        {shwYourAns && <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid flex flex-wrap align-items-center" >
            <div>
                <JVRadioBtn column={6} inline label="Your Answer" required data={["Yes", "No"]} control={control} name="submitted_Answer" />
            </div>
            <div className="field col-12 md:col-1 ">
                <Button label="SAVE" type="submit" className="md:w-8rem lg:w-8rem h-3rem"/>
            </div>
        </form>}
    </div>
}

export default ShowYourAnswers;
